export const optionCount = 7;
export const maxShownTitles = 8;
export const maxLives = 3;